var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        { staticClass: "justify-center d-flex mt-n16" },
        [
          _c(
            "v-col",
            { staticClass: "mx-auto", attrs: { lg: "4", md: "7" } },
            [
              _c("v-card", { staticClass: "card-shadow border-radius-xl" }, [
                _c("div", { staticClass: "card-padding text-center" }, [
                  _c(
                    "h5",
                    { staticClass: "text-h5 text-typo font-weight-bold" },
                    [_vm._v("Please log in...")]
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "card-padding" },
                  [
                    _c("v-text-field", {
                      staticClass:
                        "input-style font-size-input border border-radius-md placeholder-lighter text-color-light mb-4",
                      attrs: {
                        "hide-details": "",
                        outlined: "",
                        "background-color": "rgba(255,255,255,.9)",
                        color: "rgba(0,0,0,.6)",
                        light: "",
                        height: "40",
                        placeholder: "Email",
                      },
                      model: {
                        value: _vm.emailName,
                        callback: function ($$v) {
                          _vm.emailName = $$v
                        },
                        expression: "emailName",
                      },
                    }),
                    _c("v-text-field", {
                      staticClass:
                        "input-style font-size-input border border-radius-md placeholder-lighter text-color-light mb-4",
                      attrs: {
                        type: "password",
                        "hide-details": "",
                        outlined: "",
                        "background-color": "rgba(255,255,255,.9)",
                        color: "rgba(0,0,0,.6)",
                        light: "",
                        height: "40",
                        placeholder: _vm.newPasswordRequired
                          ? "Current (temporary) password"
                          : "Password",
                      },
                      on: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.goAccount()
                        },
                      },
                      model: {
                        value: _vm.password,
                        callback: function ($$v) {
                          _vm.password = $$v
                        },
                        expression: "password",
                      },
                    }),
                    _vm.newPasswordRequired
                      ? _c("v-text-field", {
                          staticClass:
                            "input-style font-size-input border border-radius-md placeholder-lighter text-color-light mb-4",
                          attrs: {
                            type: "password",
                            "hide-details": "",
                            outlined: "",
                            "background-color": "rgba(255,255,255,.9)",
                            color: "rgba(0,0,0,.6)",
                            light: "",
                            height: "40",
                            placeholder: "Choose a new password",
                          },
                          on: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.goAccount()
                            },
                          },
                          model: {
                            value: _vm.newPassword,
                            callback: function ($$v) {
                              _vm.newPassword = $$v
                            },
                            expression: "newPassword",
                          },
                        })
                      : _vm._e(),
                    _vm.errorMessage
                      ? _c("p", { staticClass: "text-sm text-danger mb-0" }, [
                          _vm._v(_vm._s(_vm.errorMessage)),
                        ])
                      : _vm._e(),
                    _c(
                      "v-btn",
                      {
                        staticClass:
                          "font-weight-bold text-uppercase btn-default bg-gradient-default py-2 px-6 me-2 mt-6 mb-2 w-100",
                        attrs: {
                          loading: _vm.loading,
                          elevation: "0",
                          ripple: false,
                          height: "43",
                          color: "#5e72e4",
                          small: "",
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.goAccount()
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.newPasswordRequired ? "Set Password" : "Log In"
                          )
                        ),
                      ]
                    ),
                    _c("p", { staticClass: "text-sm text-body mt-3 mb-0" }, [
                      _vm._v(" Forgot That Password? "),
                      _c(
                        "a",
                        {
                          staticClass:
                            "ml-2 text-dark text-decoration-none font-weight-bolder",
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.goPassword()
                            },
                          },
                        },
                        [_vm._v("Reset Here...")]
                      ),
                    ]),
                    _c("p", { staticClass: "text-sm text-body mt-1 mb-0" }, [
                      _vm._v(" No account yet? "),
                      _c(
                        "a",
                        {
                          staticClass:
                            "ml-2 text-dark text-decoration-none font-weight-bolder",
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.$router.push({
                                path: "/pages/authentication/signup/basic",
                              })
                            },
                          },
                        },
                        [_vm._v("Sign up")]
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }